import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TimeSlot } from '@checkout-v2/const';
import { NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ItemWrapperComponent } from '../../item-wrapper';

@Component({
  selector: 'sd-another-date-item',
  imports: [NgbDatepickerModule, ItemWrapperComponent],
  templateUrl: './another-date-item.component.html',
  styleUrl: './another-date-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnotherDateItemComponent {
  readonly timeSlots = input.required<TimeSlot[]>();
  readonly anotherDateSelected = output<string>();

  protected readonly dateRange = computed(() => {
    const timeSlots = this.timeSlots();
    const minDate = new Date(Math.min(...timeSlots.map((slot) => new Date(slot.date).getTime())));
    const maxDate = new Date(minDate);

    maxDate.setDate(minDate.getDate() + 8);

    return {
      min: this.convertDateToNgbDate(minDate),
      max: this.convertDateToNgbDate(maxDate),
    };
  });

  protected onDateSelect(ngbDate: NgbDateStruct): void {
    const dateString = this.convertNgbDateToDateString(ngbDate);

    this.anotherDateSelected.emit(dateString);
  }

  private convertDateToNgbDate(date: Date): NgbDateStruct {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
  }

  private convertNgbDateToDateString(ngbDate: NgbDateStruct): string {
    const date = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
}
